export default "__VITE_ASSET__G62OKMYu__"